"use client";

import { useState, useEffect } from "react";
import Business from "@/components/b2b/Business";
import ContactForm from "@/components/b2b/ContactForm";
import Hero from "@/components/b2b/Hero";
import IndustriesSection from "@/components/b2b/Industries";
import OfferingsSection from "@/components/b2b/Offer";
import StatsSection from "@/components/b2b/Stats";
import investorsData from "../../src/data/investors.json";
import Investors from "@/components/home/Investors";
import TestimonialsSection from "@/components/home/Cards";
import FAQ from "@/components/b2b/Faq";
import BrandsSection from "@/components/b2b/Brands";
import MentorsSlider from "@/components/b2b/MentorSlider";
import mentorsData from "../../src/data/mentors.json";

export default function B2B() {
  const [individualMentors, setIndividualMentors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const flattened = [];
      const source = Array.isArray(mentorsData) ? mentorsData : [];

      source.forEach((entry) => {
        for (let i = 1; i <= 12; i++) {
          const nameKey = `mentor${i}name`;
          const imageKey = `mentor${i}image`;
          const postKey = `mentor${i}post`;

          if (entry[nameKey] && entry[imageKey]) {
            const designation = entry[postKey] || "";
            let companyName = "";

            const lower = designation.toLowerCase();
            if (lower.includes(" at ")) {
              companyName = designation
                .substring(lower.lastIndexOf(" at ") + 4)
                .trim();
            } else if (designation.includes(",")) {
              companyName = designation
                .substring(designation.lastIndexOf(",") + 1)
                .trim();
            }

            flattened.push({
              mentorId: `${entry.slug || "mentor"}-${i}`,
              name: entry[nameKey],
              mainImage: entry[imageKey],
              designation,
              companyName,
            });
          }
        }
      });

      setIndividualMentors(flattened);
    } catch (error) {
      console.error("Error loading mentors:", error);
      setIndividualMentors([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <>
      <Hero />
      <BrandsSection />
      <StatsSection />
      <Business />
      <MentorsSlider individualMentors={individualMentors} />
      <IndustriesSection />
      <OfferingsSection />
      <ContactForm />
      <TestimonialsSection />
      <FAQ />
      <Investors investors={investorsData} />
    </>
  );
}
